import { useCallback, useEffect, useState } from 'react';

/** 一定スクロール後に表示し、クリックでページ先頭へスムーズスクロール */
const SHOW_AFTER_PX = 360;

export default function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTop = useCallback(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-4 z-[90] flex flex-col items-end sm:bottom-8 sm:right-6 md:right-8 ${
        visible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
      } transition-opacity duration-300 ease-out motion-reduce:transition-none`}
      aria-hidden={!visible}
    >
      <button
        type="button"
        onClick={goTop}
        className="flex h-12 w-12 items-center justify-center rounded-full border bg-white shadow-lg transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[rgba(184,155,74,0.12)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B89B4A] focus-visible:ring-offset-2 motion-reduce:transition-none sm:h-14 sm:w-14"
        style={{
          borderColor: 'rgba(184, 155, 74, 0.45)',
          color: '#B89B4A',
          boxShadow: '0 8px 28px rgba(11, 26, 42, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06)',
        }}
        aria-label="ページトップへ戻る"
        title="ページトップへ戻る"
        tabIndex={visible ? 0 : -1}
      >
        <i className="ri-arrow-up-line text-xl sm:text-2xl" aria-hidden={true} />
      </button>
      <span
        className="mt-1.5 text-[10px] font-light tracking-wider sm:text-xs"
        style={{ color: '#888', fontFamily: "'Noto Sans JP', sans-serif" }}
      >
        TOP
      </span>
    </div>
  );
}
